import React from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import styles from './TextField.scss';// to import local scss fle

const TextField = (props) => {
  const handleOnChange = (e) => {
    props.onChange(e);
  };
  /* const handleError = () => {
      // eslint-disable-next-line
    props.emptyError;
  }; */
  const showErrorMessage = renderIf(props.errorMessage !== '');
  return (
    <div className={props.errorMessage === '' ? cn('row', styles.textFieldContainer) : cn('row', styles.textFieldContainerOnError)}>
      <label className={styles.label} htmlFor="Email">{props.label}</label>
      {props.usedFor === 'forgotPassword' ?
        <Input
          htmlFor="name"
          type="password"
          onChange={handleOnChange}
          onFocus={props.onFocus}
          onKeyPress={props.onKeyPress}
        />
            :
        <Input
          htmlFor="password"
          type="text"
          className={props.usedFor === 'signupEmail' ? styles.makeEmailSmall : ''}
          onChange={handleOnChange}
          onFocus={props.onFocus}
          onKeyPress={props.onKeyPress}
        />
        }
      {showErrorMessage(
        <Error message={props.errorMessage} />,
        )}
    </div>);
};

TextField.propTypes = {
    // eslint-disable-next-line
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /* emptyError: PropTypes.func.isRequired, */
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  usedFor: PropTypes.string,
  onKeyPress: PropTypes.func.isRequired,
};

TextField.defaultProps = {
  onChange: () => {},
  label: '',
  onFocus: () => {},
  errorMessage: '',
  usedFor: '',
};


export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/TextField.js